import { render, staticRenderFns } from "./SpeakerSessionsPage.vue?vue&type=template&id=a4d4ba0a&"
import script from "./SpeakerSessionsPage.vue?vue&type=script&lang=js&"
export * from "./SpeakerSessionsPage.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerSessionsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VSkeletonLoader})
